// extracted by mini-css-extract-plugin
module.exports =  {"container":"vcG4XGpLbdZNYcDUiAZc"};